"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VERTICAL = exports.HORIZONTAL = exports.FormProvider = exports.FormConsumer = exports.Context = void 0;
var _react = require("react");
var HORIZONTAL = exports.HORIZONTAL = 'horizontal';
var VERTICAL = exports.VERTICAL = 'vertical';
var Context = exports.Context = /*#__PURE__*/(0, _react.createContext)({
  form: {
    alignment: VERTICAL,
    values: {},
    touched: {},
    errors: {}
  }
});
var FormProvider = exports.FormProvider = Context.Provider;
var FormConsumer = exports.FormConsumer = Context.Consumer;
var _default = exports["default"] = Context;